import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const Google24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight32 : s.svgDark32,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={getDataIconAttribute(chroma, icon, '32')}
  >
    <path
      d="M16.184 14.143V17.4h5.208c-.21 1.398-1.574 4.099-5.208 4.099-3.136 0-5.694-2.688-5.694-5.999 0-3.311 2.558-5.999 5.694-5.999 1.784 0 2.978.788 3.66 1.466l2.493-2.483C20.737 6.936 18.663 6 16.184 6 11.106 6 7 10.248 7 15.5s4.106 9.5 9.184 9.5c5.3 0 8.816-3.854 8.816-9.283 0-.624-.066-1.1-.144-1.574h-8.672z"
      fillRule="evenodd"
    />
  </svg>
);

export default Google24;
